export default __webpack_public_path__ + "static/media/google.95964036.jpg";